import { AUTHORIZATION_SET, AUTHORIZATION_RESET } from "actions/types";

export const setAuth = () => async dispatch => {
  dispatch({ type: AUTHORIZATION_SET, payload: null });
};

export const resetAuth = () => async dispatch => {
  dispatch({ type: AUTHORIZATION_RESET, payload: null });
};
